import "./Connect.module.css";
import MainNavigation from "@/reusable_sections/Header";
import StartAClinicalDialogue from "./sections/StartAClinicalDialogue";
import OurLakhisaraiLocation from "./sections/OurLakhisaraiLocation";
import Footer from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <MainNavigation />
      <StartAClinicalDialogue />
      <OurLakhisaraiLocation />
      <Footer />
    </div>;
}